export const faqData = [
  {
    id: 1,
    question: "How much can I save by refinancing my car?",
    answer:
      "Refinancing can lower your EMI and total interest cost, depending on the rate reduction and new loan tenure. Use Minemi’s calculator to estimate your savings.",
  },
  {
    id: 2,
    question: "Does refinancing affect my credit score?",
    answer:
      "Yes, applying for refinancing may result in a temporary dip due to hard inquiries. Timely payments on the new loan will help improve your score in the long run.",
  },
  {
    id: 3,
    question: "What documents are required for car loan refinancing?",
    answer:
      "You’ll need ID proof, vehicle registration, insurance, income proof, and a loan payoff statement.",
  },
  {
    id: 4,
    question: "Is it better to refinance with my current lender?",
    answer:
      "Not always. Compare your lender’s offer with others to ensure you’re getting the best deal.",
  },
  {
    id: 5,
    question: "Can I refinance if I have a low credit score?",
    answer:
      "Yes, but you may not get significant savings. Improve your credit score before refinancing to secure better terms.",
  },
];
